import React, { useCallback, useState } from 'react'

import { GetCard } from '@web/walter-lib/api'
import { useBreakpoints } from '@web/walter-ui-kit'
import s from './s.module.css'
import { List, SliderList } from './List'
import Balance from './Balance'
import Transactions from './Transactions'
import TopUpModal from './TopUpModal'
import { useCloseTopUp, useFirstSelectedCard, useMemorizeCard, usePreOpenTopUp } from './hooks'
import Actions from '~pages/CardsPage/Cards/Actions'
import { useCards } from '~api'
import { CardsViews } from '~pages/CardsPage/types'

interface Props {
    setView: (newView: CardsViews) => void
    setSelectedId: (id: string) => void
    selectedCard?: GetCard
}

// eslint-disable-next-line max-lines-per-function,complexity
function Cards({ setView, setSelectedId, selectedCard }: Props) {
    const [txNow, resetTx] = useState(() => Date.now())
    const { isMobile, isTablet } = useBreakpoints()
    const [topUpModal, setTopUpModal] = useState(false)

    const { data, isLoading } = useCards()

    useFirstSelectedCard(setSelectedId, selectedCard, data?.cards || [])
    useMemorizeCard(selectedCard)
    usePreOpenTopUp(setTopUpModal, selectedCard)

    const { onClose } = useCloseTopUp(setTopUpModal, resetTx)

    const setSelectedCardCb = useCallback(
        (card: GetCard) => {
            setSelectedId(card?.id)
        },
        [setSelectedId]
    )

    return (
        <>
            <TopUpModal isOpen={topUpModal} onClose={onClose} card={selectedCard} setPageView={setView} />
            <div className={s.wrap}>
                {!(isTablet || isMobile) && (
                    <div className={s.desktopList}>
                        <List
                            cards={data?.cards || []}
                            isCardsLoading={isLoading}
                            selectedCard={selectedCard}
                            setSelectedCard={setSelectedCardCb}
                        />
                    </div>
                )}
                <div className={s.dividerColumn} />
                <div className={s.right}>
                    {selectedCard && (
                        <>
                            <div className={s.topWrap}>
                                <div className={s.desktopBalance}>
                                    <Balance card={selectedCard} isCurrent />
                                </div>
                                {(isTablet || isMobile) && (
                                    <div className={s.mobileList}>
                                        <SliderList
                                            cards={data?.cards || []}
                                            isCardsLoading={isLoading}
                                            setSelectedCard={setSelectedCardCb}
                                            selectedCard={selectedCard}
                                        />
                                    </div>
                                )}
                                <div className={s.actions}>
                                    <Actions
                                        card={selectedCard}
                                        topUpModal={topUpModal}
                                        setTopUpModal={setTopUpModal}
                                    />
                                </div>
                            </div>
                            {selectedCard &&
                                selectedCard?.status !== 'PENDING' &&
                                selectedCard?.status !== 'FAILED' && (
                                    <>
                                        <div className={s.dividerRow} />
                                        <div className={s.tansactions}>
                                            <Transactions card={selectedCard} txNow={txNow} />
                                        </div>
                                    </>
                                )}
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

export default Cards
